module.exports = __webpack_public_path__ + "static/media/3.4bcd7244.png";